import useMaintenance from 'src/hooks/useMaintenance';
import useNetworkState from 'src/hooks/useNetworkState';
import { ChatWidgetWrapper } from 'src/components/ChatWidget';
import AgentChatSupportWrapper from '../AgentChatSupport/AgentChatSupportWrapper';
import AuthWrapper from '../AuthWrapper';
import config from '../../config';
import PageNoNetwork from 'src/quantum_ticketing/PageNoNetwork';
import PageOnMaintenance from 'src/quantum_ticketing/PageOnMaintenance';

const GlobalWrapper = ({ children }) => {
	const isOnline = useNetworkState();
	const { maintenanceEnabled } = useMaintenance();

	if (!isOnline) {
		return <PageNoNetwork />;
	}

	if (maintenanceEnabled) {
		return <PageOnMaintenance />;
	}

	return (
		<AuthWrapper>
			{children}
			{config.appSettings.chatSupport && (
				<>
					<ChatWidgetWrapper />
					<AgentChatSupportWrapper />
				</>
			)}
		</AuthWrapper>
	);
};

export default GlobalWrapper;
